module.exports = __webpack_public_path__ + "static/media/logo.2fd1d035.svg";